import { configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "@reduxjs/toolkit";
import cartReducer from "./slices/cartSlice";

const peresistConfig = {
  key: "RP",
  version: 1,
  storage,
};
const reducer = combineReducers({
  cart: cartReducer,
});

const persistedReducer = persistReducer(peresistConfig, reducer);

export const store = configureStore({
  reducer: persistedReducer,
});
